import { CheckoutFooter } from '@/components/CheckoutFooter';
import { CheckoutHeader } from '@/components/CheckoutHeader';
import { CheckoutSeparator } from '@/components/CheckoutSeparator';
import { ContactSection } from '@/components/ContactSection';
import { DeliveryDetails } from '@/components/DeliveryDetails';
import { ExpressCheckout } from '@/components/ExpressCheckout';
import { OrderSummary } from '@/components/OrderSummary';
import { Payment } from '@/components/Payment';
import { PayNowButton } from '@/components/PayNowButton';
import { useCheckout } from '@/contexts/checkoutContext';
import { usePageData } from '@/contexts/pageContext';
import { useBeginCheckout } from '@/hooks/useBeginCheckout';
import * as Styled from './CheckoutApp.styled';

export const CheckoutApp = () => {
  const { cartServiceMessage, footerLinks, urls } = usePageData();
  const {
    checkoutData: { amounts, discountCode, items },
  } = useCheckout();

  useBeginCheckout();

  return (
    <Styled.OuterPageWrapper>
      <Styled.InnerPageWrapper>
        <CheckoutHeader basketUrl={urls.basket} />
        <Styled.ContentWrapper>
          <Styled.OrderDetails>
            <OrderSummary orders={items} subtotal={amounts?.total} />
          </Styled.OrderDetails>
          <Styled.CheckOutDetails>
            <ExpressCheckout />
            <CheckoutSeparator />
            <ContactSection />
            <DeliveryDetails />
            <Payment data={{ amounts, cartServiceMessage, discountCode }} />
            <PayNowButton />
          </Styled.CheckOutDetails>
        </Styled.ContentWrapper>
        {footerLinks ? <CheckoutFooter links={footerLinks} /> : null}
      </Styled.InnerPageWrapper>
    </Styled.OuterPageWrapper>
  );
};
